<template>
	<div class="width-100 height-100 display-flex flex-column">
		<div class="permission-text">With edit and share permissions, teammates will be able to:</div>
		<div v-for="permission in permissionTypesDescriptions.allowedPermissions" :key="permission" class="permission-text">
			<SIcon class="mr-1" name="successfull-connection" /> {{ permission }}
		</div>
		<div class="permission-text mt-6">Teammates will NOT be able to:</div>
		<div v-for="permission in permissionTypesDescriptions.restrictedPermissions" :key="permission" class="permission-text">
			<SIcon class="mr-1" name="configuration-error" /> {{ permission }}
		</div>
	</div>
</template>

<script>
import { PERMISSIONS_DESCRIPTIONS_MAP, ALL_PERMISSIONS } from '@/utils/projects.const';

export default {
	name: 'CollaboratorsPermissionsExplanation',
	props: {
		permissionType: { type: String },
	},
	computed: {
		permissionTypesDescriptions() {
			if (!this.permissionType) {
				return {};
			}
			const allowedPermissions = PERMISSIONS_DESCRIPTIONS_MAP[this.permissionType];
			const restrictedPermissions = ALL_PERMISSIONS.filter((p) => !allowedPermissions.includes(p));
			return { allowedPermissions, restrictedPermissions };
		},
	},
	data() {
		return {
			allowedPermissions: [
				{ text: 'Edit and use features and connections' },
				{ text: 'Manage who can use features' },
				{ text: 'See task log' },
			],
			restrictedPermissions: [{ text: 'Manage collaborators' }, { text: 'Edit space settings' }],
		};
	},
};
</script>

<style scoped lang="scss">
.title-description {
	font-weight: 400;
	font-size: 12px;
	line-height: 23px;
	color: #9e9e9e;
}
.permission-text {
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4d4c52;
}
</style>
